<div class="container-fluid welcome-screen">
  <div class="row">
    <div class="col-md-12 ">
      <div class="elem-p welcome-screen-branding-container">
        <div class="elem-c">
          <div class="branding " title="Countable">
            <!-- <span class="icon-adinovis"></span> -->
            <img style="height: 60px;" src="/assets/images/logo/countable-header-logo.svg" alt="Countable">
          </div>
          <p>Adapt. Improve. Grow</p>
        </div>
      </div>
    </div>
  </div>
  <div class="elem-p">
    <div class="elem-c">
      <div class="box">
        <div class="row box-content">
          <h6 class="header-title">{{statusMessage}}</h6>
          <!-- <div class="books b-left">
            <div class="book-figure">
              <img src="/assets/images/quickbooks_logo.png" alt="quickbooks" />
            </div>
            <div class="book-btn">
              <button mat-raised-button class="secondary-btn" (click)="quickbookConnect()" color="primary">{{quickbookStatus == 1 ? 'Connected' : 'Connect'}}</button>
            </div>
          </div>
          <div class="books b-right">
            <div class="book-figure">
              <img src="../../../../assets/images/logo-xero-blue.svg" alt="xero" />
            </div>
            <div class="book-btn">
              <button mat-raised-button class="secondary-btn" (click)="xeroConnect()" color="primary">{{xeroStatus == 1 ? 'Connected' : 'Connect'}}</button>
            </div>
          </div> -->
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 dark box-footer">
          <button class="text-link" (click)="openTermsPrivacyDialog('terms-of-Use')" style="font-size: 14px;">Terms of Use</button>
          <span class="devider"></span>
          <button class="text-link" (click)="openTermsPrivacyDialog('privacy-policy')" style="font-size: 14px;">Privacy Policy</button>
        </div>
      </div>
    </div>
  </div>
</div>

